import {
  faBracketsSquare,
  faCommand,
} from "@fortawesome/pro-regular-svg-icons";

import { useChangeTabShortcut } from "../../hooks/useChangeTabShortcut";
import { useGlobalCommandbarStore } from "../../store";
import { CommandbarShortcutKeys } from "../../types/common";
import CommandbarShortcutIcon from "../ShortcutIcon";

export default function ChangeTabs() {
  useChangeTabShortcut();

  const shotcutKeysPressed = useGlobalCommandbarStore(
    st => st.shotcutKeysPressed,
  );

  return (
    <div className="flex items-center gap-2">
      <CommandbarShortcutIcon
        icon={faCommand}
        highlight={shotcutKeysPressed[CommandbarShortcutKeys.META]}
      />
      <CommandbarShortcutIcon
        icon={faBracketsSquare}
        highlight={
          shotcutKeysPressed[CommandbarShortcutKeys.LEFT_SQUARE_BRACKET] ||
          shotcutKeysPressed[CommandbarShortcutKeys.RIGHT_SQUARE_BRACKET]
        }
      />
      Change tabs
    </div>
  );
}
